var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#F3F6ED",
    stroke: "#A2BE71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.118 17V7.965H12.498C13.486 7.965 14.2357 8.16433 14.747 8.563C15.267 8.96167 15.527 9.54233 15.527 10.305C15.527 10.7903 15.3883 11.2107 15.111 11.566C14.8423 11.9127 14.4913 12.1337 14.058 12.229C14.682 12.3763 15.163 12.6363 15.501 13.009C15.839 13.3817 16.008 13.8583 16.008 14.439C16.008 15.271 15.735 15.908 15.189 16.35C14.6517 16.7833 13.876 17 12.862 17H9.118ZM10.223 11.852H12.524C13.122 11.852 13.577 11.7263 13.889 11.475C14.2097 11.215 14.37 10.8423 14.37 10.357C14.37 9.40367 13.7547 8.927 12.524 8.927H10.223V11.852ZM10.223 16.038H12.797C13.4557 16.038 13.9627 15.9037 14.318 15.635C14.6733 15.3577 14.851 14.959 14.851 14.439C14.851 13.919 14.669 13.5203 14.305 13.243C13.9497 12.957 13.434 12.814 12.758 12.814H10.223V16.038Z",
    fill: "#8EB052"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterB);
export default __webpack_public_path__ + "static/media/letterB.d00409daf9a885fedd2f454eae06db08.svg";
export { ForwardRef as ReactComponent };